import 'rxjs/add/operator/switchMap';
import * as moment from 'moment';

import { Component,
         OnInit,
         AfterViewInit,
         Output,
         EventEmitter,
         ElementRef,
         Input,
         ChangeDetectorRef}         from '@angular/core';
import { DomSanitizer,
         SafeHtml }                 from '@angular/platform-browser';
import { SortDirection,
         ISortableFilter }          from './sortable-filter';
import { Globals }                  from './globals';
import { ActivatedRoute,
         Router }                   from '@angular/router';
import { Observable }               from 'rxjs/Observable';
import { TableColumn,
         TableColumnType }          from './table-column';
import { createGuid }               from './../common/functions';

@Component({
  selector: 'sa-grid-template',
  template: require('./grid.template.html'),
  styles: ['./grid.template.scss']
})
export class GridTemplateComponent<T> implements OnInit, AfterViewInit {

  @Output() editItem = new EventEmitter();
  @Input() public columns: Array<TableColumn>;
  @Input() public filterChanged: EventEmitter<any>;
  @Input() public selectedUpdated: EventEmitter<T>;
  @Input() public dataCallback: Function;
  @Input() public dataPageCallback: Function;
  @Input() public searchCallback: Function;

  @Input() public rowClassCallback: Function;

  @Input() pageSize = 10;
  @Input() pagingDisabled = false;

  @Input() defferLoading = false;

  @Input() sortingDisabled = false;
  @Input() filter: ISortableFilter;
  @Input() title: string;

  items: Observable<T[]>;
  selectedId: string;

  totalCount = 0;
  page = 1;
  loading = true;

  exception = false;

  rowClassValue: string = null;

  exceptionMessage: SafeHtml = null;

  paginationServerID = createGuid();

  sortOrder: Object;

  sortDirection = SortDirection;

  colTypes = TableColumnType;

  index = () => { return (this.page - 1) * this.pageSize; };

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private globals: Globals,
    private el: ElementRef,
    private sanitizer: DomSanitizer,
    private changeDetectionRef: ChangeDetectorRef
  ) {
  }

  isSelected(selectedItem: T, column: TableColumn = null) {
    if (!!column && !!column.callbackFunction) {
      column.callbackFunction(selectedItem);
      return;
    }
    this.editItem.emit(selectedItem);
  }

  ngOnInit() {
    this.filterChanged.subscribe((filter: ISortableFilter) => {
        this.filter = filter;
        this.getPage(1);
      });
  }

  // Custom template for pagination:  http://michaelbromley.github.io/ng2-pagination/#/custom-template
  getPage(page: number) {
      this.loading = true;
      this.exception = false;
      this.page = page;

      if (this.pagingDisabled) {
        this.items = this.dataCallback(this.filter)
          .do(res => {
              this.pageSize = res.length;
              this.totalCount = res.length;
              this.loading = false;
          })
          .map(res => res)
          .catch(res => {
            this.showError(res);
          });
      } else {
        this.filter.page = this.page;
        this.filter.pageSize = this.pageSize;
        this.items = this.dataPageCallback(this.filter)
            .do(res => {
                this.totalCount = res.total;
                this.loading = false;
            })
            .map(res => res.items)
            .catch(res => {
              this.showError(res);
            });
      }
  }

  sortBy(column: TableColumn) {
    if (this.sortingDisabled || !column.sortable) {
      return;
    }

    if (!!this.filter && column.name === this.filter.sortColumn) {
        if (this.filter.sortDirection === SortDirection.asc) {
          this.filter.sortDirection = SortDirection.desc;
        } else if (this.filter.sortDirection === SortDirection.desc) {
          this.filter.sortDirection = SortDirection.asc;
        }
    } else {
      this.filter.sortDirection = SortDirection.asc;
    }

    this.filter.sortColumn = column.name;
    this.getPage(this.page);
  }

  rowClass(item: any) {
    if (typeof item.rowClassValue === 'undefined') {
      if (!!this.rowClassCallback) {
        item.rowClassValue = this.rowClassCallback(item);
      } else {
          item.rowClassValue = '';
        }
    }
    return item.rowClassValue
  }

  colClass(val: any, col: TableColumn) {
    // TODO: Hashmap to cache and optimize speed
      if (!!col.columnClassFunction) {
        return col.columnClassFunction(val);
      }
      return '';
  }

  format(val: any, col: TableColumn): SafeHtml {
      if (val === null || val === 'undefined') {
        return '';
      }

      if (!!col.getValueFunction) {
        val = col.getValueFunction(val);
      }

      if (!!col.formatFunction) {
        if (col.type === TableColumnType.HTML) {
          return col.formatFunction(val);
        }
        return this.sanitizer.bypassSecurityTrustHtml(col.formatFunction(val));
    }

    if (col.type === TableColumnType.HTML) {
        return val;
    }

      if (col.type === TableColumnType.Money && typeof val === 'number') {
        return val.toFixed(2);
      }
      if (col.type === TableColumnType.Bool) {
          if (!!val) {
            return this.sanitizer.bypassSecurityTrustHtml('<i class="material-icons checkbox_true">check_box</i>');
          } else {
            return this.sanitizer.bypassSecurityTrustHtml('<i class="material-icons checkbox_false">check_box_outline_blank</i>');
          }
      }
      if (col.type === TableColumnType.DayOfMonth) {
          return new Date(val).getDate() + '';
      }
      if (col.type === TableColumnType.Date) {
        return moment(val).format('DD.MM.YYYY');
      }
      if (col.type === TableColumnType.DateTime) {
          return moment(val).format('HH:mm DD/MM/YYYY');
      }
      if (col.type === TableColumnType.DateTime2) {
          return moment(val).format('DD.MM.YYYY HH:mm');
      }
      // if (col.type === TableColumnType.Array) {
      //     let tmpArray = val;
      // }
      return this.sanitizer.bypassSecurityTrustHtml(val);
  }

  getValue(item: any, valuePath: string): string {
    let paths = valuePath.split('.');
    if (paths.length === 1) {
      return item.getProp(paths[0]);
    } else {
      return this.getValue(item.getProp(paths[0]), paths.splice(1).join('.'));
    }
  }

  ngAfterViewInit() {
    if (!this.defferLoading) {
        this.getPage(1);
    } else {
        this.loading = false;
        // FIX: Expression has changed after it was checked.
        // See https://github.com/angular/angular/issues/6005
        this.changeDetectionRef.detectChanges();
    }
  }

  showError(res) {
    this.exception = true;
    this.loading = false;
    if (!!res.message && res.message.length > 0) {
      this.exceptionMessage = this.sanitizer.bypassSecurityTrustHtml(res.message);
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/common/grid.template.component.ts